import sidebarConfig from './SidebarConfig';
import axios from '../../utils/axios';
import { PATH_DASHBOARD } from '../../routes/paths';
import {
  getDarkModeVatFallbackPath,
  isDarkModeFacility,
  isDarkModeRestrictedVatPath
} from '../../utils/facilityMode';

/** Resolve sidebar moduleId for a path (longest path match). Null = shared pages (dashboard/profile). */
export function getModuleIdForPath(pathname) {
  let bestModuleId = null;
  let bestLen = 0;
  const walk = (item, parentModuleId) => {
    const mod = item.moduleId || parentModuleId || null;
    if (item.path && pathname.startsWith(item.path) && item.path.length >= bestLen) {
      bestModuleId = mod;
      bestLen = item.path.length;
    }
    (item.children || []).forEach((child) => walk(child, mod));
  };
  (sidebarConfig || []).forEach((group) => {
    (group.items || []).forEach((item) => walk(item, item.moduleId));
  });
  return bestModuleId;
}

/** Stay on current route if module exists on target facility; else dashboard. */
export async function getFacilitySwitchTarget(facilityId) {
  const fallback = PATH_DASHBOARD.general.maindashboard;
  const pathname = window.location.pathname || '';

  // Dark Mode facilities may only keep Credit Notes & Refunds among VAT reports.
  if (isDarkModeFacility(facilityId) && isDarkModeRestrictedVatPath(pathname)) {
    return getDarkModeVatFallbackPath();
  }

  try {
    const modulesResponse = await axios.get(`/api/facilities/${facilityId}/modules`);
    const allowedModules = modulesResponse.data.modules
      ? String(modulesResponse.data.modules).split(',')
      : [];
    const moduleId = getModuleIdForPath(pathname);
    if (!moduleId || allowedModules.includes(String(moduleId))) {
      return `${pathname}${window.location.search || ''}`;
    }
  } catch (error) {
    console.error('Failed to resolve facility redirect', error);
  }
  return fallback;
}
